module.exports = __webpack_public_path__ + "ef866b5983d0be0362547ffd256f19f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/iconfont.svg
// module id = 354
// module chunks = 0 204 209